// i18next-extract-mark-ns-start EventPhoto
import React from 'react';
import { CarouselProvider, Slider, Slide } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import { GatsbyImage } from 'gatsby-plugin-image';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';

class EventPhoto extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false, index: 0 };
  }

  render() {
    return (
      <CarouselProvider
        naturalSlideWidth={100}
        naturalSlideHeight={this.props.height}
        totalSlides={this.props.slides.length}
        visibleSlides={1}
        step={1}
        infinite={true}
        isPlaying={true}
        interval={3000}
        orientation="vertical"
        lockOnWindowScroll={true}
      >
        <Lightbox
          open={this.state.open}
          close={() => this.setState({ open: false })}
          slides={this.props.slides.map(item => ({
            src: item.image.publicURL,
          }))}
          index={this.state.index}
        />
        <Slider className="cursor-pointer" classNameAnimation="duration-2000">
          {this.props.slides.map((item, index) => (
            <Slide
              key={index}
              onClick={() => this.setState({ open: true, index: index })}
            >
              <GatsbyImage
                className=""
                image={item.image.childImageSharp.gatsbyImageData}
              />
            </Slide>
          ))}
        </Slider>
      </CarouselProvider>
    );
  }
}

EventPhoto.displayName = 'EventPhoto';

export default EventPhoto;
